export class ContractSignatureError extends Error {
  /**
   * @param {String|Number}
   */
  code

  constructor(message, code) {
    super(message)

    this.code = code
  }
}
